import { ReactNode } from "react";
import { Toaster } from "@components/common/Toaster";
import { useToastStore } from "@stores/toastStore";

export const ToasterProvider = ({ children }: { children: ReactNode }) => {
  const toasts = useToastStore((state) => state.toasts);

  return (
    <>
      {children}
      <div>
        {toasts.map((toast) => (
          <Toaster
            key={toast.id}
            type={toast.type}
            text={toast.text}
            duration={toast.duration}
          />
        ))}
      </div>
    </>
  );
};
